import type { ReactNode } from 'react';

export const symbol_book_5: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M270-80q-45 0-77.5-29.64Q160-139.27 160-183v-564q0-36.57 22.12-65.43Q204.24-841.3 240-849l308-64q28-6 50 12.14T620-854v497q0 21.16-13 37.58Q594-303 573-298l-313 67q-17.14 3.69-28.57 17.54Q220-199.62 220-183q0 19 15 31t35 12h470v-630q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v630q0 24.75-17.62 42.37Q764.75-80 740-80H270Zm70-228 220-47v-499l-220 45v501Zm-60 12.81V-796l-20 4q-17 4-28.5 15.83Q220-764.35 220-747v471q9.06-5.2 19.03-9.1Q249-289 260-291l20-4.19ZM220-792v516-516Z"
		/>
	</svg>
);
